// import React, { useEffect, useState } from 'react'
// import UploadCoupon from '../panelComponents/AllCouponsComponent/UploadCoupon';
// import SummaryApi from '../common/SummaryApi';
// import AdminCouponCard from '../panelComponents/AllCouponsComponent/AdminCouponCard';

// const AllCoupons = () => {
//   const [openUpload, setOpenUpload] = useState(false)
//   const [allCoupons, setAllCoupons] = useState([])
//   const [isLoading, setIsLoading] = useState(true)

//   const fetchAllCoupons = async () => {
//     setIsLoading(true);
//     try {
//       const response = await fetch(SummaryApi.allCoupons.url)
//       const dataResponse = await response.json()
//       setAllCoupons(dataResponse?.data || []);
//     } catch (err) {
//       console.error('Failed to fetch coupons');
//     } finally {
//       setIsLoading(false);
//     }
//   }

//   useEffect(() => {
//     fetchAllCoupons()
//   }, [])

//   return (
//     <div className="min-h-screen">
//       <div className='py-2 flex justify-between items-center rounded-lg'>
//         <h2 className='font-bold text-xl text-gray-900'>All Coupons</h2>
//         <button 
//           className='border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white transition-all py-2 px-4 rounded-full' 
//           onClick={() => setOpenUpload(true)}
//         >
//           Add New Coupon
//         </button>
//       </div>

//       <div className="bg-gray-100 p-6 mt-4 rounded-lg">
//         {isLoading ? (
//           <p className="text-center py-10">Loading coupons...</p>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {allCoupons.map((coupon) => (
//               <AdminCouponCard
//                 key={coupon._id}
//                 data={coupon}
//                 fetchData={fetchAllCoupons}
//               />
//             ))}
//           </div>
//         )}
//       </div>

//       {openUpload && (
//         <UploadCoupon onClose={() => setOpenUpload(false)} fetchData={fetchAllCoupons} />
//       )}
//     </div>
//   )
// }

// export default AllCoupons

import React, { useEffect, useState } from 'react'
import UploadCoupon from '../panelComponents/AllCouponsComponent/UploadCoupon';
import SummaryApi from '../common/SummaryApi';
import AdminCouponCard from '../panelComponents/AllCouponsComponent/AdminCouponCard';

const AllCoupons = () => {
  const [openUpload, setOpenUpload] = useState(false)
  const [allCoupons, setAllCoupons] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const fetchAllCoupons = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(SummaryApi.allCoupons.url, {
          method: SummaryApi.allCoupons.method,
          headers: {
              "content-type": "application/json"
          }
      })
      const dataResponse = await response.json()
      
      if(dataResponse.success){
          setAllCoupons(dataResponse?.data || []);
      }
    } catch (err) {
      console.error('Failed to fetch coupons', err);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchAllCoupons()
  }, [])

  return (
    <div className="min-h-screen">
      <div className='pb-2 flex justify-between items-center rounded-lg mb-4'>
        <h2 className='font-bold text-2xl text-gray-900'>Coupons</h2>
        <button 
          className='bg-blue-600 text-white hover:bg-blue-700 transition-all py-2 px-6 rounded-lg font-semibold shadow-md' 
          onClick={() => setOpenUpload(true)}
        >
          + Add New Coupon
        </button>
      </div>

      <div className="mt-4">
        {isLoading ? (
          <div className="flex justify-center items-center h-64">
             <p className="text-gray-500 animate-pulse font-medium">Loading your coupons...</p>
          </div>
        ) : allCoupons.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {allCoupons.map((coupon) => (
              <AdminCouponCard
                key={coupon._id}
                data={coupon}
                fetchData={fetchAllCoupons}
              />
            ))}
          </div>
        ) : (
            <div className='text-center py-20 bg-white rounded-xl border-2 border-dashed border-gray-200'>
                <p className='text-gray-400'>No coupons found. Create your first one!</p>
            </div>
        )}
      </div>

      {openUpload && (
        <UploadCoupon onClose={() => setOpenUpload(false)} fetchData={fetchAllCoupons} />
      )}
    </div>
  )
}

export default AllCoupons